import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { SmartTextWidget } from 'libs/gb-dashboard/presenter/data-access-presenter-widgets/src/lib/+state/presenter-widgets.models'
import { GbPresenterColorResolverService } from 'libs/gb-dashboard/presenter/utils/src/lib/gb-presenter-color-resolver.service'
@Component({
  selector: 'gb-presenter-widget-smart-text',
  imports: [],
  templateUrl: './gb-presenter-widget-smart-text.component.html',
  styleUrl: './gb-presenter-widget-smart-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterWidgetSmartTextComponent {
  @Input({ required: true }) smartTextWidget!: SmartTextWidget
  @Input() auction?: string | null
  @Input() testData: boolean = false

  constructor(private colorResolver: GbPresenterColorResolverService) {}

  get auctionValue(): string {
    return this.testData ? 'campaign' : (this.auction ?? '')
  }

  get fontFamily(): string {
    return this.smartTextWidget?.font_family || this.colorResolver.globalFontFamily() || 'Arial, sans-serif'
  }

  get fontSize(): number {
    return (this.smartTextWidget?.font_size ?? 0) / 8
  }

  get textColor(): string {
    return (
      this.colorResolver.resolve(this.smartTextWidget?.color) || this.colorResolver.resolvedGlobalColor() || '#000000'
    )
  }
}
